(() => {
  const body = document.body;
  const header = document.querySelector("[data-site-header]");
  const syncHeaderHeight = () => {
    if (header) document.documentElement.style.setProperty("--header-h", `${header.offsetHeight}px`);
  };
  syncHeaderHeight();
  window.addEventListener("resize", syncHeaderHeight);
  const menu = document.getElementById("MainMenu");
  const backdrop = document.querySelector(".menu-backdrop");
  const menuButton = document.querySelector("[data-menu-open]");

  const setMenu = (open) => {
    if (!menu) return;
    menu.classList.toggle("is-open", open);
    backdrop?.classList.toggle("is-open", open);
    menu.setAttribute("aria-hidden", String(!open));
    menuButton?.setAttribute("aria-expanded", String(open));
    body.classList.toggle("menu-open", open);
  };

  menuButton?.addEventListener("click", () => setMenu(true));
  document.querySelectorAll("[data-menu-close]").forEach((el) =>
    el.addEventListener("click", () => setMenu(false))
  );
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      setMenu(false);
      closeSidePanels();
    }
  });

  if (header && body.classList.contains("template-index")) {
    const updateHeader = () => header.classList.toggle("is-solid", window.scrollY > 32);
    updateHeader();
    window.addEventListener("scroll", updateHeader, { passive: true });
  }

  function closeSidePanels() {
    document.querySelectorAll(".side-panel.is-open").forEach((panel) => {
      panel.classList.remove("is-open");
      panel.setAttribute("aria-hidden", "true");
    });
    document.querySelectorAll("[data-drawer-toggle].is-open").forEach((tab) => {
      tab.classList.remove("is-open");
      tab.setAttribute("aria-expanded", "false");
    });
  }

  document.querySelectorAll("[data-drawer-toggle]").forEach((tab) => {
    tab.addEventListener("click", () => {
      const panel = document.getElementById(tab.dataset.drawerToggle);
      const willOpen = !panel?.classList.contains("is-open");
      closeSidePanels();
      if (willOpen && panel) {
        panel.classList.add("is-open");
        panel.setAttribute("aria-hidden", "false");
        tab.classList.add("is-open");
        tab.setAttribute("aria-expanded", "true");
      }
    });
  });
  document.querySelectorAll("[data-drawer-close]").forEach((button) =>
    button.addEventListener("click", closeSidePanels)
  );

  const ageGate = document.querySelector("[data-age-gate]");
  const cookieBanner = document.querySelector("[data-cookie-banner]");
  if (ageGate && localStorage.getItem("dampfe-age-confirmed-v1") !== "yes") {
    ageGate.hidden = false;
    body.classList.add("modal-open");
  } else if (cookieBanner && !localStorage.getItem("dampfe-cookie-choice-v1")) {
    cookieBanner.hidden = false;
  }
  document.querySelector("[data-age-confirm]")?.addEventListener("click", () => {
    localStorage.setItem("dampfe-age-confirmed-v1", "yes");
    ageGate.hidden = true;
    body.classList.remove("modal-open");
    if (cookieBanner && !localStorage.getItem("dampfe-cookie-choice-v1")) cookieBanner.hidden = false;
  });
  document.querySelectorAll("[data-cookie-choice]").forEach((button) =>
    button.addEventListener("click", () => {
      localStorage.setItem("dampfe-cookie-choice-v1", button.dataset.cookieChoice);
      if (cookieBanner) cookieBanner.hidden = true;
    })
  );
  document.querySelectorAll("[data-cookie-reopen]").forEach((button) =>
    button.addEventListener("click", () => {
      localStorage.removeItem("dampfe-cookie-choice-v1");
      if (cookieBanner) cookieBanner.hidden = false;
    })
  );

  const eventNodes = [...document.querySelectorAll("[data-event-source] [data-event]")];
  const parseEvent = (node) => {
    const date = String(node.dataset.date || "").trim();
    const time = String(node.dataset.time || "18:00").trim();
    const start = new Date(`${date}T${time.length === 5 ? time : "18:00"}:00`);
    return {
      date,
      time,
      title: node.dataset.title || "",
      type: node.dataset.type || "",
      link: node.dataset.link || "/pages/live-musik-kalender",
      start
    };
  };
  const events = eventNodes.map(parseEvent).filter((event) => !Number.isNaN(event.start.valueOf()));
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  const upcoming = events.filter((event) => event.start >= startOfToday).sort((a, b) => a.start - b.start);
  const formatDate = (date, options) => new Intl.DateTimeFormat("de-DE", options).format(date);

 const nextEventsCard = document.querySelector("[data-next-events]");

if (nextEventsCard && upcoming.length) {
  const nextEventItems = [...nextEventsCard.querySelectorAll("[data-next-event]")];
  const nextKicker = nextEventsCard.querySelector("[data-next-kicker]");
  const firstEventIsToday =
    upcoming[0].start.toDateString() === new Date().toDateString();

  if (nextKicker) {
    nextKicker.textContent = firstEventIsToday
      ? "Heute in der Dampfe"
      : "Als Nächstes in der Dampfe";
  }

  nextEventItems.forEach((item, index) => {
    const event = upcoming[index];

    if (!event) {
      item.hidden = true;
      return;
    }

    item.hidden = false;
    item.href = event.link;

    item.querySelector("[data-next-date]").textContent =
      `${formatDate(event.start, {
        day: "numeric",
        month: "long"
      })} · ab ${event.time.replace(":", ".")} Uhr`;

    item.querySelector("[data-next-title]").textContent = event.title;
    item.querySelector("[data-next-type]").textContent = event.type;
  });
}

  const list = document.querySelector("[data-upcoming-list]");
  if (list) {
    list.innerHTML = "";
    const requestedLimit = Number.parseInt(list.dataset.eventLimit || "3", 10);
    const eventLimit = Number.isFinite(requestedLimit) ? requestedLimit : 3;
    upcoming.slice(0, eventLimit).forEach((event) => {
      const link = document.createElement("a");
      link.href = event.link;
      link.innerHTML = `<span>${formatDate(event.start, { day: "numeric", month: "long" })}</span><strong>${escapeHtml(event.title)}</strong><em>Ab ${escapeHtml(event.time.replace(":", "."))} Uhr</em><b>↗</b>`;
      list.append(link);
    });
  }

  document.querySelectorAll("[data-event-calendar]").forEach((calendar) => {
    const target = calendar.querySelector("[data-calendar-months]");
    if (!target) return;
    const eventSource = document.querySelector("[data-event-source]");
    const eyebrow = calendar.querySelector("[data-calendar-eyebrow]");
    const heading = calendar.querySelector("[data-calendar-heading]");
    const intro = calendar.querySelector("[data-calendar-text]");
    if (eyebrow && eventSource?.dataset.calendarEyebrow) eyebrow.textContent = eventSource.dataset.calendarEyebrow;
    if (heading && eventSource?.dataset.calendarHeading) heading.textContent = eventSource.dataset.calendarHeading;
    if (intro && eventSource?.dataset.calendarText) intro.textContent = eventSource.dataset.calendarText;
    const groups = new Map();
    events.sort((a, b) => a.start - b.start).forEach((event) => {
      const key = `${event.start.getFullYear()}-${event.start.getMonth()}`;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(event);
    });
    target.innerHTML = "";
    groups.forEach((monthEvents) => {
      const first = monthEvents[0].start;
      const article = document.createElement("article");
      article.className = "calendar-month";
      const cards = monthEvents.map((event) => {
        const weekday = formatDate(event.start, { weekday: "short" }).replace(".", "");
        const day = event.start.getDate();
        return `<a class="calendar-day has-event" href="${escapeAttribute(event.link)}"><span class="calendar-date"><strong>${day}</strong><span>${weekday}</span></span><span class="calendar-event"><strong>${escapeHtml(event.title)}</strong><small>${escapeHtml(event.type)} · ${escapeHtml(event.time.replace(":", "."))} Uhr</small></span></a>`;
      }).join("");
      article.innerHTML = `<div class="calendar-month-heading"><h3>${formatDate(first, { month: "long" })}</h3><span>${first.getFullYear()}</span></div><div class="calendar-event-grid">${cards}</div>`;
      target.append(article);
    });
  });

  function escapeHtml(value) {
    const el = document.createElement("span");
    el.textContent = value;
    return el.innerHTML;
  }
  function escapeAttribute(value) {
    return String(value).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
  }

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      if (event.submitter?.name !== "add") return;
      event.preventDefault();
      const button = event.submitter;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = "Wird hinzugefügt …";
      try {
        const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error("add failed");
        const cart = await fetch(window.Shopify.routes.root + "cart.js").then((res) => res.json());
        document.querySelectorAll("[data-cart-count]").forEach((count) => count.textContent = cart.item_count);
        document.querySelectorAll(".header-cart").forEach((cartLink) => cartLink.classList.toggle("is-empty", cart.item_count === 0));
        button.textContent = "Im Warenkorb";
      } catch {
        form.submit();
      } finally {
        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = original;
        }, 1400);
      }
    });
  });

  document.querySelectorAll("[data-product-section]").forEach((section) => {
    const select = section.querySelector("[data-variant-select]");
    const radios = [...section.querySelectorAll('.product-options input[type="radio"]')];
    if (!select || !radios.length) return;
    radios.forEach((radio) => radio.addEventListener("change", () => {
      const chosen = [];
      const names = [...new Set(radios.map((input) => input.name))];
      names.forEach((name) => chosen.push(section.querySelector(`input[name="${name}"]:checked`)?.value || ""));
      const option = [...select.options].find((item) => item.dataset.options?.split("||").every((value, index) => value === chosen[index]));
      if (option) {
        select.value = option.value;
        const url = new URL(window.location.href);
        url.searchParams.set("variant", option.value);
        window.history.replaceState({}, "", url);
      }
    }));
  });
})();
